import React from 'react';

const permissionContext = React.createContext();

export default permissionContext;
